import { Component, computed, inject, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { LabelComponent } from '../../../../../common/label/label.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import {
  OccupationPreviewComponent
} from '../../common/occupation-data-section/components/occupation-preview/occupation-preview.component';
import {
  occupationsToFormValue,
  RoadOccupationFormValue
} from '../../common/occupation-data-section/forms/road-occupation.form';
import { OccupationLabelPipe } from '../../common/occupation-data-section/pipes/occupation-label.pipe';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';

@Component({
  selector: 'app-take-over-lane-reconstruction-of-exit-preview',
  standalone: true,
  imports: [
    LabelComponent,
    DecisionDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    OccupationPreviewComponent,
    OccupationLabelPipe,
    PaymentsDataPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    CommonModule,
    ContractorDataPreviewComponent
  ],
  templateUrl: './take-over-lane-reconstruction-of-exit-preview.component.html'
})
export class TakeOverLaneReconstructionOfExitPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  private store$: Store = inject(Store);

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public roadOccupations: Signal<RoadOccupationFormValue[]> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []));

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public ngOnInit(): void {
  }
}
